import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: fixed;
    width: 100%;
    height: auto;
    bottom: 17%;
    left: 90%;
    right: 0;
    background-color: #10F5B0;
    border-radius: .3em;

    transform: translateX(6.9%);
    transition: transform .3s ease-in-out;
    z-index: 101;

    .phone-icon {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        text-decoration: none;

        .icon {
            padding: 1em;
        }

        .phone {
            color: #000000;
            font-weight: 700;
        }
    }

    &:hover {
        transform: translateX(-3%);
        cursor: pointer;
    }

    @media all and (max-width: ${variables.mobileM}) {
        display: none;
    }
`;